import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { stylesShareSite } from "../../shareSiteStylesMui/ShareSiteStylesMuiComponents";
import { ListTypeOfData } from "../../../../../redux/slices/shareSite/shareSiteTypes";

type ShareSiteTypeOfFilterParams = {
  setSelectTypeOfFilter: (value: string) => void;
  typeSelected: string;
  listTypeOfFilter: ListTypeOfData[];
  listTypeOfLoading: boolean;
  storagesLoading: boolean;
  storageSharingLoading: boolean;
  storageSharedDeleteLoading: boolean;
};

const ShareSiteTypeOfFilter: FC<ShareSiteTypeOfFilterParams> = ({
  setSelectTypeOfFilter,
  typeSelected,
  listTypeOfFilter,
  listTypeOfLoading,
  storagesLoading,
  storageSharingLoading,
  storageSharedDeleteLoading,
}) => {
  const [t] = useTranslation("global");

  return (
    <Box>
      <FormControl sx={stylesShareSite.filterInputs} fullWidth>
        <InputLabel id="demo-simple-select-label">
          {t("Common_options.select")}
        </InputLabel>
        <Select
          value={typeSelected}
          label={t("Common_options.select")}
          onChange={(e) => setSelectTypeOfFilter(e.target.value as any)}
          disabled={
            listTypeOfLoading ||
            storagesLoading ||
            storageSharedDeleteLoading ||
            storageSharingLoading
          }
        >
          {listTypeOfFilter.map((values) => (
            <MenuItem key={values.id} value={values.id}>
              {values.nameTextId.text}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default ShareSiteTypeOfFilter;
